import { useState } from 'react';
import { updateNewCreditDate as updateNewCreditDateLS } from 'services/services';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

export const useEditCommittedPaymentDateForLogisticService = () => {
  const [isLoading, setIsLoading] = useState(false);

  const editDate = async (id: number, date: string) => {
    setIsLoading(true);
    try {
      await updateNewCreditDateLS(id, date);
      displaySuccessNotification({ customJSXMessage: <>La fecha de compromiso se guardo correctamente</> });
      return true;
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };
  return { isLoading, editDate };
};
